export default "__VITE_ASSET__BWpaeiwh__"